"use strict";

import BaseModel from "dias/core/models/baseModel";

class Rubriken extends BaseModel {
  constructor() {
    super("rubriken");
  }
}

export default Rubriken;
